import React from 'react';
import ShowProductEnableProperties from "./ShowProductEnableProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import {useStyles} from "./ShowProductEnable.style";
import clsx from "clsx";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const ShowProductEnable: React.FC<ShowProductEnableProperties> = ({
                                                          value,
                                                          className = '',
                                                      }) => {

    const i18n = useI18nContext();
    const classes = useStyles();

    if (!value) {
        return <></>;
    }

    console.log(11111, value)

    const Icon = value.enabled ? CheckCircleIcon : CancelIcon;

    return (
        <div className={clsx(classes.show_product_enable_container, className, value.enabled ? classes.active : classes.inactive)}>
            <Icon className={classes.icon}/>
            <div className={classes.text}>{i18n.translate(value.enabled ? "ACTIVE" : "INACTIVE")}</div> {value.enabled}
        </div>
    )
}


export default ShowProductEnable;